<template>
  <van-popup
    v-model="show"
    closeable
    close-icon="close"
    style="background: transparent;"
    :close-on-click-overlay="false"
  >
    <div
      v-if="slotInfo"
      :style="sizeStyle"
      @click="onClick(false)"
    >
      <img
        :src="source.imgUrl"
      />
      <div
        v-if="source.showSeconds"
        class="ad-showTime"
      >
        广告将在<span class="time">{{ showTime }}</span>秒后跳转
      </div>
      <div
        v-if="source.tag"
        class="ad-tip"
      >
        <span><van-icon name="info-o" />广告由第三方提供</span>
      </div>
    </div>
  </van-popup>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin],
  data() {
    return {
      closed: false,
      showTime: 0,
      showTimer: null,
      jumpTimer: null,
    };
  },
  computed: {
    show: {
      get() {
        const { closed, showSlotInfo } = this;
        return !closed && showSlotInfo;
      },
      set(value) {
        this.closed = !value;
        clearInterval(this.showTimer);
        clearTimeout(this.jumpTimer);
      },
    },
    source() {
      const { slotInfo } = this;
      return slotInfo && slotInfo.sourceList && slotInfo.sourceList[0];
    },
  },
  watch: {
    show(value) {
      if (value) {
        const { showSeconds, autoJumpSecond, autoJump } = this.source;
        this.showTime = showSeconds;
        if (autoJump && autoJumpSecond > 0) this.jumpTimer = setTimeout(this.onClick, autoJumpSecond * 1000);
        if (showSeconds > 0) this.showTimer = setInterval(this.reduceTime, 1000);
        this.sendMV(this.source, {});
      }
    },
  },
  methods: {
    onClick(autoJump = true) {
      const { source } = this;
      this.sendMC(source, {});
      const link = (autoJump && source.autoJumpLinkData) || source.linkData;
      window.location.href = this.formatLandingPage(link, {});
    },
    reduceTime() {
      this.showTime -= 1;
      if (this.showTime <= 0) {
        this.show = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.van-popup {
  overflow: visible;

  /deep/ .van-icon-close {
    top: -50px;
    right: 0;
  }
}
.ad-showTime {
  position: absolute;
  top: 1px;
  right: 80px;
  color: white;

  .time {
    display: inline-block;
    width: 20px;
    text-align: center;
  }
}
.ad-tip {
  position: absolute;
  top: -40px;
  padding: 2px;
  color: #fff;
  width: 100%;
  z-index: -1;
  transform: scale(1.2);
  span{
    background: #000;
    padding: 4px 10px;
    border-radius: 8px 8px 0 0;
    font-size: 12px;
    position: relative;
    &::before{
      content: " ";
      display: block;
      position: absolute;
      left: -40px;
      top: 4px;
      border: 31px solid transparent;
      border-right: 10px solid #000;
    }
    &::after{
      content: " ";
      display: block;
      position: absolute;
      right: -40px;
      top: 4px;
      border: 31px solid transparent;
      border-left: 10px solid #000;
    }
  }
}
</style>
